import PropTypes from 'prop-types'
import React from 'react'
import Stepper from '../../shared/components/Stepper'

export default function ReleaseNav({
  onChange,
  section,
  steps,
  type,
}) {

  return (
    <div className={`${type} container`}>
      <div className="form form-horizontal">
        <Stepper
          active={section}
          onChange={onChange}
          steps={steps}
        />
      </div>
    </div>
  )

}

ReleaseNav.propTypes = {
  onChange: PropTypes.func,
  section: PropTypes.string,
  steps: PropTypes.array,
  type: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/release/components/ReleaseStepper.js